(() => {
  const SELECTOR = '[data-axess-category-menu]';

  function activate(menu, key) {
    const triggers = [...menu.querySelectorAll('[data-axess-category-trigger]')];
    const panels = [...menu.querySelectorAll('[data-axess-category-panel]')];
    const activeTrigger = triggers.find((trigger) => trigger.dataset.axessCategoryTrigger === key);
    const activePanel = panels.find((panel) => panel.dataset.axessCategoryPanel === key);

    if (!activeTrigger || !activePanel) return;

    triggers.forEach((trigger) => {
      const isActive = trigger === activeTrigger;
      trigger.classList.toggle('is-active', isActive);
      if (isActive) trigger.setAttribute('aria-current', 'true');
      else trigger.removeAttribute('aria-current');
    });

    panels.forEach((panel) => {
      const isActive = panel === activePanel;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  function bind(menu) {
    if (menu.dataset.axessCategoryBound === 'true') return;
    menu.dataset.axessCategoryBound = 'true';

    const summary = menu.querySelector('.axess-category-menu__summary');
    const triggers = [...menu.querySelectorAll('[data-axess-category-trigger]')];

    const syncGeometry = () => {
      if (!summary) return;
      const rect = summary.getBoundingClientRect();
      const positioningContext = menu.closest('.header__row--bottom');
      const contextTop = positioningContext?.getBoundingClientRect().top || 0;
      menu.style.setProperty('--axess-category-menu-anchor-top', `${Math.max(0, rect.bottom - contextTop)}px`);
      menu.style.setProperty('--axess-category-menu-top', `${Math.max(0, rect.bottom)}px`);
    };

    let geometryFrame;
    const scheduleGeometrySync = () => {
      cancelAnimationFrame(geometryFrame);
      geometryFrame = requestAnimationFrame(syncGeometry);
    };

    syncGeometry();
    menu.addEventListener('mouseenter', syncGeometry);
    menu.addEventListener('focusin', syncGeometry);
    summary?.addEventListener('pointerdown', syncGeometry);
    window.addEventListener('resize', scheduleGeometrySync, { passive: true });
    window.addEventListener('scroll', scheduleGeometrySync, { passive: true });

    triggers.forEach((trigger, index) => {
      const showPanel = () => activate(menu, trigger.dataset.axessCategoryTrigger);
      trigger.addEventListener('mouseenter', showPanel);
      trigger.addEventListener('focus', showPanel);

      trigger.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = index;
        if (event.key === 'ArrowDown') nextIndex = (index + 1) % triggers.length;
        if (event.key === 'ArrowUp') nextIndex = (index - 1 + triggers.length) % triggers.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = triggers.length - 1;

        triggers[nextIndex]?.focus();
      });
    });
  }

  function init(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
